module.exports = __webpack_public_path__ + "static/img/27.c44863e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/Brochure/27.jpg
// module id = cdW/
// module chunks = 1